<div class="guts-m-b-1-half">
  <!-- Endorsed list -->
  <dgx-search-results [results]="results"></dgx-search-results>

  <!-- "Load More" button -->
  <ng-container *ngIf="mayLoadEndorsedContent">
    <div class="grid__col-12 guts-p-v-0 l_flex-row">
      <button
        [disabled]="isLoading"
        (click)="loadEndorsedContent.emit()"
        class="center-item endorsed-section__expand"
        df-button
        dfButtonType="passive"
        data-dgat="search-view-v2-fac"
      >
        <span *ngIf="isLoading" class="l_flex m-l_flex l_flex-middle">
          {{ i18n.Core_Loading }}
          <df-spinner
            class="endorsed-section__spinner guts-m-l-1"
            spinnerContext="button"
          ></df-spinner>
        </span>
        <span *ngIf="!isLoading">
          {{ i18n.Core_LoadMore }}
          <df-icon icon="chevron-down" size="small"></df-icon>
        </span>
      </button>
    </div>
  </ng-container>
</div>
